document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('email-input');
  if (input) {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var form = document.getElementById('email-form');
        if (form) form.submit();
      }
    });
  }
});
